// Injured players never count in a client-side group value. Every skip reads the row's
// flag through isInjured, and the group values this module guards go through the
// helpers below. A missing flag means healthy, so a payload without
// `injured` gives the same numbers as before.

// The sandbox table keeps one flag per column, because each column is its own query
// with its own date range.
export const columnInjuredKey = (queryId) => "__injured_" + queryId;

export function isInjured(row, queryId) {
  if (row == null) return false;
  if (queryId !== undefined && queryId !== null) return row[columnInjuredKey(queryId)] === true;
  return row.injured === true;
}

const defaultIsInjured = (row) => isInjured(row);

function toNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

// The numeric values of the healthy rows. A null, undefined or non-numeric value is
// dropped, so it never enters a divisor.
export function healthyValues(rows, valueOf, isInjuredOf = defaultIsInjured) {
  const values = [];
  if (!Array.isArray(rows)) return values;
  for (const row of rows) {
    if (isInjuredOf(row)) continue;
    const n = toNumber(valueOf(row));
    if (n !== null) values.push(n);
  }
  return values;
}

export function healthySum(rows, valueOf, isInjuredOf = defaultIsInjured) {
  const values = healthyValues(rows, valueOf, isInjuredOf);
  return values.length === 0 ? null : values.reduce((sum, v) => sum + v, 0);
}

export function healthyMean(rows, valueOf, isInjuredOf = defaultIsInjured) {
  const values = healthyValues(rows, valueOf, isInjuredOf);
  return values.length === 0 ? null : values.reduce((sum, v) => sum + v, 0) / values.length;
}

export function healthyMax(rows, valueOf, isInjuredOf = defaultIsInjured) {
  const values = healthyValues(rows, valueOf, isInjuredOf);
  return values.length === 0 ? null : Math.max(...values);
}

export function healthyMin(rows, valueOf, isInjuredOf = defaultIsInjured) {
  const values = healthyValues(rows, valueOf, isInjuredOf);
  return values.length === 0 ? null : Math.min(...values);
}
